<template>
  <div class="spinners">
    <div class="spinners-icons">
      <FontAwesomeIcon class="spinner-1" :icon="faGear"/>
      <FontAwesomeIcon class="spinner-2" :icon="faGear"/>
    </div>
    <p class="spinners-text">{{ text }}</p>
  </div>

</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';

@Options({
  components: { FontAwesomeIcon },
  props: {
    text: {
      type: String,
      required: false,
    },
  },
})
export default class Spinner extends Vue {
  text;
  faGear = faGear;
}
</script>
<style scoped lang="scss">

.spinners {
  display: flex;
  flex-direction: column;
  width: fit-content;
  height: fit-content;

  &-text {
    font-weight: bold;
  }

  &-icons {
    display: flex;
  }

  .spinner {
    &-1 {
      animation: rotate 2s linear infinite;
      font-size: 4rem;
    }

    &-2 {
      margin-top: 20%;
      animation: rotateAntiClockwise 2s linear infinite;
      font-size: 2rem;
    }
  }
}

@keyframes rotateAntiClockwise {
  from {
    transform: rotate(360deg);;
  }
  to {
    transform: rotate(0deg);
  }
}
</style>
